<template>
    <section class="container-fluid">
        <div class="row mcas">
            <div class="col-md-6 col-lg-4 main">
                <div class="row" id="warea">
                    <div class="col-12 nav-top">
                        <div class="row">
                            <div class="col-2 xtl"><span class="nav-back wt" onclick="window.location.href='#/'"></span>
                            </div>
                            <div class="col-8 tfw-5 tf-18">Andhar Bahar</div>
                            <div class="col-2 xtr mcpl" @click="readrule()">Rule</div>
                        </div>
                    </div>
                    <div class="col-12 gmxcfm_ab">
                        <div class="row mt-2 tfwr pt-2">
                            <div class="col-6 xtl">
                                <div class="tf-14 mb-2">Period</div>
                                <div class="tf-24 period" id="cpd">{{ userdetails.period }}</div>
                            </div>
                            <div class="col-6 xtr">
                                <div class="tf-14 mb-2">Count Down</div>
                                <div class="cd" id="demo"><span class="cdspn">0</span><span class="cdspn">0</span>:<span
                                        class="cdspn" id="fs0">4</span><span class="cdspn" id="fs1">7</span></div>
                                <div class="cd" id="ndemo" style="display: none;"><span class="cdspn">0</span><span
                                        class="cdspn">0</span>:<span class="cdspn" id="fs0">0</span><span class="cdspn"
                                        id="fs1">0</span></div>
                                <div id="cdx"></div>
                            </div>
                        </div>
                        <div class="row mt-2">
                            <div class="col-12 mb-3 xtc">
                                <div class="cardv" id="upsc">
                                    <img class="cardv" id="upimg1" :src='image.i1'
                                        style="margin-top: 144px; display: none;">
                                    <img class="cardv" id="upimg2" :src='image.i2'
                                        style="margin-top: 144px; display: none;">
                                    <img class="cardv" id="upimg3" :src='image.i3'
                                        style="margin-top: 144px; display: none;">
                                    <img class="cardv" id="upimg4" :src='image.i4'
                                        style="margin-top: 144px; display: none;">
                                    <img class="cardv" id="upimg5" :src='image.i5'
                                        style="margin-top: 144px; display: none;">
                                    <img class="cardv" id="upimg6" :src='image.i6'
                                        style="margin-top: 144px; display: none;">
                                    <img class="cardv" id="upimg7" :src='image.i7'
                                        style="margin-top: 144px; display: none;">
                                    <img class="cardv" id="upimg8" :src='image.i8'
                                        style="margin-top: 144px; display: none;">
                                    <img class="cardv" id="upimg9" :src='image.i9'
                                        style="margin-top: 144px; display: none;">
                                </div>
                            </div>
                            <div class="col-12 pa-0 gsbgi">
                                <div id="candh">
                                    <img :src='image.andar' class="cardv wt" id="upand">
                                    <img class="cardv wt crdand" id="a1" :src="image.i1" style="display: none;">
                                    <img class="cardv wt crdand" id="a2" :src="image.i2" style="display: none;">
                                    <img class="cardv wt crdand" id="a3" :src="image.i3" style="display: none;">
                                    <img class="cardv wt crdand" id="a4" :src="image.i4" style="display: none;">
                                    <img class="cardv wt crdand" id="a5" :src="image.i5" style="display: none;">
                                    <img class="cardv wt crdand" id="a6" :src="image.i6" style="display: none;">
                                    <img class="cardv wt crdand" id="a7" :src="image.i7" style="display: none;">
                                    <img class="cardv wt crdand" id="a8" :src="image.i8" style="display: none;">
                                    <img class="cardv wt crdand" id="a9" :src="image.i9" style="display: none;">

                                </div>


                                <div id="upanc">
                                    <img class="cardv alc" id="waicard" :src='image.middle'>
                                    <img class="anmcrd" id="m1" :src="image.i1" style="display:none;">
                                    <img class="anmcrd" id="m2" :src="image.i2" style="display:none;">
                                    <img class="anmcrd" id="m3" :src="image.i3" style="display:none;">
                                    <img class="anmcrd" id="m4" :src="image.i4" style="display:none;">
                                    <img class="anmcrd" id="m5" :src="image.i5" style="display:none;">
                                    <img class="anmcrd" id="m6" :src="image.i6" style="display:none;">
                                    <img class="anmcrd" id="m7" :src="image.i7" style="display:none;">
                                    <img class="anmcrd" id="m8" :src="image.i8" style="display:none;">
                                    <img class="anmcrd" id="m9" :src="image.i9" style="display:none;">


                                </div>


                                <div id="cbnh">
                                    <img class="cardv wt" id="upbnd" :src='image.bahar'>
                                    <img class="cardv wt crdbnd" id="b1" :src="image.i1" style="display: none;">
                                    <img class="cardv wt crdbnd" id="b2" :src="image.i2" style="display: none;">
                                    <img class="cardv wt crdbnd" id="b3" :src="image.i3" style="display: none;">
                                    <img class="cardv wt crdbnd" id="b4" :src="image.i4" style="display: none;">
                                    <img class="cardv wt crdbnd" id="b5" :src="image.i5" style="display: none;">
                                    <img class="cardv wt crdbnd" id="b6" :src="image.i6" style="display: none;">
                                    <img class="cardv wt crdbnd" id="b7" :src="image.i7" style="display: none;">
                                    <img class="cardv wt crdbnd" id="b8" :src="image.i8" style="display: none;">
                                    <img class="cardv wt crdbnd" id="b9" :src="image.i9" style="display: none;">

                                </div>
                            </div>
                        </div>
                        <div class="row mr-0 mt-4 pb-3 tf-18">
                            <div class="col-4 pa-0">
                                <div class="join andar" id="jaba" @click="join('Andhar')">
                                    <div class="tflh-56 tfw-5">Andar</div>
                                </div>
                                <div class="tflh-10 tf-14 tfcdg pt-1">1:2</div>
                            </div>
                            <div class="col-4 pa-0">
                                <div class="join tie" id="jabb" @click="join('Tie')">
                                    <div class="tflh-56 tfw-5">Tie</div>
                                </div>
                                <div class="tflh-10 tf-14 tfcdg pt-1">1:9</div>
                            </div>
                            <div class="col-4 pa-0">
                                <div class="join bahar" id="jabt" @click="join('Bahar')">
                                    <div class="tflh-56 tfw-5">Bahar</div>
                                </div>
                                <div class="tflh-10 tf-14 tfcdg pt-1">1:2</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="row" id="nfrm" style="display:none;">
                            <div class="col-12 pa-0 odbox bslidein">
                                <div :class="betclass('xsel')" id="nxsel">Join {{ betbox.title }}</div>
                                <div class="row bfard">
                                    <div class="col-6 xtl tfcdb tf-20 tffss">₹<span class="tf-28" id="u_bal">{{
                                        userdetails.balance
                                    }}</span>
                                    </div>
                                    <div class="col-6 pl-0 pr-1 xtr pt-1">
                                        <div class="rc-wal" onclick="window.location.href='#/recharge'">Recharge
                                        </div>
                                    </div>
                                </div>
                                <div class="row mr-0 pa-10">
                                    <div class="col-12 xtl">Contract Money</div>
                                    <div class="col-12 tf-16 xtl" id="factorlist">
                                        <div :class="betclass('cont-amt selected')" id="10" @click="selectmultiply(10)">
                                            10</div>
                                        <div :class="betclass('cont-amt')" id="100" @click="selectmultiply(100)">100
                                        </div>
                                        <div :class="betclass('cont-amt')" id="1000" @click="selectmultiply(1000)">
                                            1000
                                        </div>
                                        <div :class="betclass('cont-amt')" id="10000" @click="selectmultiply(10000)">
                                            10000</div>
                                    </div>
                                </div>
                                <div class="row mr-0 pa-10">
                                    <div class="col-12 xtl">
                                        <div class="silb mr-2">Number</div>
                                        <div class="row">
                                            <div class="col-5 xtl pr-0"><span class="xpan" id="xm5"
                                                    @click="minus(5)">-5</span><span class="xpan" id="xm"
                                                    @click="minus(1)">-1</span></div>
                                            <div class="col-2 xtc"><span class="xnum" id="xn">{{
                                                betbox.multiply
                                            }}</span>
                                            </div>
                                            <div class="col-5 xtr pl-0"><span class="xpan" id="xp"
                                                    @click="plus(1)">+1</span><span class="xpan" id="xp5"
                                                    @click="plus(5)">+5</span></div>
                                        </div>
                                    </div>
                                    <div class="col-12 mt-2 tf-16 xtl">Total contract money is <span id="tca">{{
                                        betbox.amount
                                    }}</span>
                                    </div>
                                </div>
                                <div class="row mr-0 mb-2">
                                    <div class="col-12 xtr">
                                        <div :class="betclass('btn-con newod')" id="nod" @click="confirmbet()">
                                            Confirm
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 betfbg" id="blackscreen" @click="closescreen()" style="display: none;"></div>
                    <div class="col-12 mt-2">
                        <div class="row tffm h264">
                            <div class="col-12 tfw-7 tabin active" id="rcdv">Record</div>
                            <div class="col-12">
                                <div class="row tf-16 mr-0" id="xrecd">
                                    <div class="col-8 mt-2 mb-2 pb-2 pl-0 xtl tf-18 tfcdb">AndharBahar Record(s)</div>
                                    <div class="col-4 mt-2 mb-2 pb-2 pr-0 tf-14 xtr"><span class="mcpl tfcdg"
                                            onclick="window.location.href='#/record?server=AndharBahar'">more
                                            &gt;</span>
                                    </div>
                                    <div class="col-12">
                                        <div class="row record">


                                            <div class="rcd-pillar mb-2" v-for="row in resultrec" :key="row.id">
                                                <div :class="getresclass(row.ans)">
                                                    <div class="tpr">{{ row.ans }}</div>
                                                </div>
                                                <div class="rcd-per">{{ row.period % 1000 }}</div>
                                            </div>

                                            <div class="rcd-pillar mb-2" id="upcp">
                                                <div class="per-rcd dn upn"><b>?</b></div>
                                                <div class="rcd-per">{{ userdetails.period % 1000 }}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row mr-0" id="capr"></div>
                            </div>
                        </div>
                        <div class="row mr-0" id="lfprd"></div>
                        <div class="row mt-2">
                            <div class="col-6 tfw-6 tffm tabin active" id="every" @click="everyoneorder()">Everyone's
                                Order
                            </div>
                            <div class="col-6 tfw-6 tffm tabin" id="my" @click="myorder()">My Order</div>
                            <div class="col-12" id="myorder" style="display: none;">
                                <div class="row plr-10 pb-2">
                                    <div class="col-12 pb-3 pt-2 tf-14 dflx">
                                        <div class="wd-100 xtl">Period</div>
                                        <div class="wd-36">Select</div>
                                        <div class="wd-46">Point</div>
                                        <div class="wd-36">Result</div>
                                        <div class="wd-80 xtr">Amount</div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-12" id="mywod"></div>
                                    <div class="col-12" id="myod">
                                        <div class="row plr-10">
                                            <div class="col-12 lih-32 pt-2 pb-2 dflx" v-for="rows in betrec" :key="rows.id"
                                                :rowsrec="rows">
                                                <div class="wd-100 xtl">{{ rows.period }}</div>
                                                <div class="wd-36"><span :class="getresclass(rows.ans)">{{
                                                    short(rows.ans)
                                                }}</span></div>
                                                <div class="wd-46">{{ rows.amount }}</div>
                                                <div class="wd-36" v-html="getele(rows.number)">

                                                </div>
                                                <div class="wd-80 xtr" v-html="betamount(rows.amount,rows.res, rows.ans )">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-12">
                                        <div class="m-order"
                                            onclick="window.location.href='#/orderrecord?server=AndharBahar'">
                                            more &gt;</div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12" id="everyoneorder">
                                <div class="row">
                                    <div class="col-4 tf-14 pt-2 xtl">Period</div>
                                    <div class="col-3 tf-14 pt-2">User</div>
                                    <div class="col-2 tf-14 pt-2">Select</div>
                                    <div class="col-3 tf-14 pt-2 xtr">Point</div>
                                </div>
                                <div class="row">
                                    <marquee direction="down" id="everyone" scrollamount="3">
                                        <div class="col-12" id="abeod">
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{ userdetails.period }}</div>
                                                <div class="col-3 cgray">***984</div>
                                                <div class="col-2 "><span class="GS A">A</span></div>
                                                <div class="col-3 xtr">₹10</div>
                                            </div>

                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{ userdetails.period }}</div>
                                                <div class="col-3 cgray">***546</div>
                                                <div class="col-2 "><span class="GS A">A</span></div>
                                                <div class="col-3 xtr">₹500</div>
                                            </div>
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{ userdetails.period }}</div>
                                                <div class="col-3 cgray">***315</div>
                                                <div class="col-2 "><span class="GS A">A</span></div>
                                                <div class="col-3 xtr">₹10000</div>
                                            </div>
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{ userdetails.period }}</div>
                                                <div class="col-3 cgray">***443</div>
                                                <div class="col-2 "><span class="VS T">T</span></div>
                                                <div class="col-3 xtr">₹10</div>
                                            </div>
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{ userdetails.period }}</div>
                                                <div class="col-3 cgray">***864</div>
                                                <div class="col-2 "><span class="RS B">B</span></div>
                                                <div class="col-3 xtr">₹12000</div>
                                            </div>
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{ userdetails.period }}</div>
                                                <div class="col-3 cgray">***082</div>
                                                <div class="col-2 "><span class="GS A">A</span></div>
                                                <div class="col-3 xtr">₹10000</div>
                                            </div>
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{ userdetails.period }}</div>
                                                <div class="col-3 cgray">***549</div>
                                                <div class="col-2 "><span class="VS T">T</span></div>
                                                <div class="col-3 xtr">₹1000</div>
                                            </div>
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{ userdetails.period }}</div>
                                                <div class="col-3 cgray">***010</div>
                                                <div class="col-2 "><span class="VS T">T</span></div>
                                                <div class="col-3 xtr">₹100</div>
                                            </div>
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{ userdetails.period }}</div>
                                                <div class="col-3 cgray">***349</div>
                                                <div class="col-2 "><span class="RS B">B</span></div>
                                                <div class="col-3 xtr">₹10</div>
                                            </div>
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{ userdetails.period }}</div>
                                                <div class="col-3 cgray">***322</div>
                                                <div class="col-2 "><span class="RS B">B</span></div>
                                                <div class="col-3 xtr">₹1000</div>
                                            </div>
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{ userdetails.period }}</div>
                                                <div class="col-3 cgray">***475</div>
                                                <div class="col-2 "><span class="RS B">B</span></div>
                                                <div class="col-3 xtr">₹10</div>
                                            </div>
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{ userdetails.period }}</div>
                                                <div class="col-3 cgray">***233</div>
                                                <div class="col-2 "><span class="GS A">A</span></div>
                                                <div class="col-3 xtr">₹100</div>
                                            </div>
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{ userdetails.period }}</div>
                                                <div class="col-3 cgray">***955</div>
                                                <div class="col-2 "><span class="RS B">B</span></div>
                                                <div class="col-3 xtr">₹10</div>
                                            </div>
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{ userdetails.period }}</div>
                                                <div class="col-3 cgray">***684</div>
                                                <div class="col-2 "><span class="VS T">T</span></div>
                                                <div class="col-3 xtr">₹50</div>
                                            </div>
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{ userdetails.period }}</div>
                                                <div class="col-3 cgray">***141</div>
                                                <div class="col-2 "><span class="GS A">A</span></div>
                                                <div class="col-3 xtr">₹20</div>
                                            </div>
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{ userdetails.period }}</div>
                                                <div class="col-3 cgray">***818</div>
                                                <div class="col-2 "><span class="GS A">A</span></div>
                                                <div class="col-3 xtr">₹50</div>
                                            </div>
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{ userdetails.period }}</div>
                                                <div class="col-3 cgray">***470</div>
                                                <div class="col-2 "><span class="GS A">A</span></div>
                                                <div class="col-3 xtr">₹10</div>
                                            </div>
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{ userdetails.period }}</div>
                                                <div class="col-3 cgray">***613</div>
                                                <div class="col-2 "><span class="RS B">B</span></div>
                                                <div class="col-3 xtr">₹100</div>
                                            </div>
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{ userdetails.period }}</div>
                                                <div class="col-3 cgray">***892</div>
                                                <div class="col-2 "><span class="RS B">B</span></div>
                                                <div class="col-3 xtr">₹10</div>
                                            </div>
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{ userdetails.period }}</div>
                                                <div class="col-3 cgray">***365</div>
                                                <div class="col-2 "><span class="RS B">B</span></div>
                                                <div class="col-3 xtr">₹10</div>
                                            </div>
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{ userdetails.period }}</div>
                                                <div class="col-3 cgray">***928</div>
                                                <div class="col-2 "><span class="VS T">T</span></div>
                                                <div class="col-3 xtr">₹20</div>
                                            </div>
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{ userdetails.period }}</div>
                                                <div class="col-3 cgray">***981</div>
                                                <div class="col-2 "><span class="VS T">T</span></div>
                                                <div class="col-3 xtr">₹100</div>
                                            </div>
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{ userdetails.period }}</div>
                                                <div class="col-3 cgray">***239</div>
                                                <div class="col-2 "><span class="RS B">B</span></div>
                                                <div class="col-3 xtr">₹100</div>
                                            </div>
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{ userdetails.period }}</div>
                                                <div class="col-3 cgray">***393</div>
                                                <div class="col-2 "><span class="GS A">A</span></div>
                                                <div class="col-3 xtr">₹100</div>
                                            </div>
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{ userdetails.period }}</div>
                                                <div class="col-3 cgray">***562</div>
                                                <div class="col-2 "><span class="GS A">A</span></div>
                                                <div class="col-3 xtr">₹50</div>
                                            </div>
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{ userdetails.period }}</div>
                                                <div class="col-3 cgray">***661</div>
                                                <div class="col-2 "><span class="VS T">T</span></div>
                                                <div class="col-3 xtr">₹10</div>
                                            </div>
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{ userdetails.period }}</div>
                                                <div class="col-3 cgray">***938</div>
                                                <div class="col-2 "><span class="RS B">B</span></div>
                                                <div class="col-3 xtr">₹50</div>
                                            </div>
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{ userdetails.period }}</div>
                                                <div class="col-3 cgray">***069</div>
                                                <div class="col-2 "><span class="GS A">A</span></div>
                                                <div class="col-3 xtr">₹10</div>
                                            </div>
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{ userdetails.period }}</div>
                                                <div class="col-3 cgray">***573</div>
                                                <div class="col-2 "><span class="RS B">B</span></div>
                                                <div class="col-3 xtr">₹10</div>
                                            </div>
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{ userdetails.period }}</div>
                                                <div class="col-3 cgray">***034</div>
                                                <div class="col-2 "><span class="RS B">B</span></div>
                                                <div class="col-3 xtr">₹10</div>
                                            </div>
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{ userdetails.period }}</div>
                                                <div class="col-3 cgray">***057</div>
                                                <div class="col-2 "><span class="RS B">B</span></div>
                                                <div class="col-3 xtr">₹2000</div>
                                            </div>
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{ userdetails.period }}</div>
                                                <div class="col-3 cgray">***227</div>
                                                <div class="col-2 "><span class="VS T">T</span></div>
                                                <div class="col-3 xtr">₹5000</div>
                                            </div>
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{ userdetails.period }}</div>
                                                <div class="col-3 cgray">***643</div>
                                                <div class="col-2 "><span class="GS A">A</span></div>
                                                <div class="col-3 xtr">₹2000</div>
                                            </div>
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{ userdetails.period }}</div>
                                                <div class="col-3 cgray">***755</div>
                                                <div class="col-2 "><span class="GS A">A</span></div>
                                                <div class="col-3 xtr">₹10</div>
                                            </div>
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{ userdetails.period }}</div>
                                                <div class="col-3 cgray">***199</div>
                                                <div class="col-2 "><span class="RS B">B</span></div>
                                                <div class="col-3 xtr">₹4000</div>
                                            </div>
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{ userdetails.period }}</div>
                                                <div class="col-3 cgray">***581</div>
                                                <div class="col-2 "><span class="GS A">A</span></div>
                                                <div class="col-3 xtr">₹10000</div>
                                            </div>
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{ userdetails.period }}</div>
                                                <div class="col-3 cgray">***060</div>
                                                <div class="col-2 "><span class="GS A">A</span></div>
                                                <div class="col-3 xtr">₹4000</div>
                                            </div>
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{ userdetails.period }}</div>
                                                <div class="col-3 cgray">***352</div>
                                                <div class="col-2 "><span class="GS A">A</span></div>
                                                <div class="col-3 xtr">₹80</div>
                                            </div>
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{ userdetails.period }}</div>
                                                <div class="col-3 cgray">***060</div>
                                                <div class="col-2 "><span class="VS T">T</span></div>
                                                <div class="col-3 xtr">₹10</div>
                                            </div>
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{ userdetails.period }}</div>
                                                <div class="col-3 cgray">***984</div>
                                                <div class="col-2 "><span class="GS A">A</span></div>
                                                <div class="col-3 xtr">₹10</div>
                                            </div>

                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{ userdetails.period }}</div>
                                                <div class="col-3 cgray">***984</div>
                                                <div class="col-2 "><span class="GS A">A</span></div>
                                                <div class="col-3 xtr">₹10</div>
                                            </div>
                                        </div>
                                    </marquee>
                                </div>
                            </div>

                        </div>
                        <div class="row mr-0 mordm"></div>
                    </div>
                    <div class="col-12 betfbg" id="bfbg" onclick="clsbfrm()"></div>
                    <div class="col-12" id="ucheck"></div>
                    <div class="col-12" id="suc-fail">
                        <div class="col-12 conod" @click="resclose()" id="rlink" style="display: none;" >
                            <div class="row podfs fadein" id="smgid">
                                <div :class="getrcl(result.res)">{{ getr(result.res) }}</div>
                                <div class="col-12" v-if="result.res === 'success'"><img class="winxIMG" src="../assets/includes/images/win.png" width="320"></div>
                                <div class="col-12 pt-2 pb-2"><span :class="getcl(result.number)" >{{result.number}}</span></div>
                                <div class="col-12">
                                    <div class="row tfcdb tf-16 xtl">
                                        <div class="col-4 pb-1">Period</div>
                                        <div class="col-8 pb-1 xtr">{{result.period}}</div>
                                        <div class="col-4">Price</div>
                                        <div class="col-8 xtr">{{result.price}}</div>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="row tfcdb selwnlbx xtl">
                                        <div class="col-4 pl-1 pb-1">Select</div>
                                        <div class="col-8 pr-1 xtr pb-1"><span :class="resclass(result.ans)" >{{result.ans}}</span></div>
                                        <div class="col-4 pl-1 pb-1">Point</div>
                                        <div class="col-8 pr-1 xtr pb-1 tf-16">{{result.amount}}</div>
                                        <div class="col-4 pl-1 pb-1">Amount</div>
                                        <div class="col-8 pr-1 xtr pl-0 pb-1 tf-24 tfwr" v-html="betamount(result.amount,result.res, result.ans )">
                                            
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 mb-3">
                                    <div class="btn-main act">CLOSE</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 bbg" id="xrule" style="display: none;">
                        <div class="col-12 botfrm bslidein" style="display: block;">
                            <div class="tf-20 mt-3 mb-3"><span class="grlm">AndharBahar Rule</span></div>
                            <div class="row mt-2 pb-2 tfcdb grh-60">
                                <div class="col-12 xtl tf-16">
                                    <div class="justify">Andar Bahar is a guessing game, you can choose Andar, Bahar, or
                                        Tie.</div>
                                    <div class="justify pt-2">50 seconds to order, after the order time, Show a hole
                                        card first. Then, in the order of Andar → Bahar, the cards are dealt in turn,
                                        and the card with the same number of points as the hole card is dealt first, and
                                        which side wins.</div>
                                    <div class="justify pt-2">If the hole card shows a 2, then Andar and Bahar, whoever
                                        shows the 2 first, wins. If no 2 is shown in 8 consecutive cards, it is a tie.
                                    </div>
                                    <div class="justify pt-2">If you spend ₹100 to trade, after deducting 2 rupees
                                        service fee, your contract amount is 98 rupees:</div>
                                </div>
                                <div class="col-12 tfs-b tf-14 pt-2 justify">
                                    <ul class="pl-4">
                                        <li class="pt-1">Buy Andar: Andar will first show 2 and you will get (98 * 2)
                                            196 rupees;</li>
                                        <li class="pt-1">Buy Bahar: Bahar will first show 2 and you will get (98 * 2)
                                            196 rupees;</li>
                                        <li class="pt-1">Buy a Tie: If both Andar and Bahar do not show 2, you will get
                                            (98 * 9) 882 rupees.</li>
                                    </ul>
                                </div>
                                <div class="col-12 fixn">
                                    <div class="btn-con cls" @click="closerule()">I GOT IT</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row" id="odrea"></div>
                <div class="row" id="footer"></div>
                <div class="row" id="opffp"></div>
                <div class="row" id="anof">

                </div>
                <div class="row" id="clink" style="display:none">
                    <div class="col-12 conod LR" @click="cpop()">
                        <div class="ssmg fadein">
                            <div class="tf-14 pb-2" id="message"> </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>


import axios from "axios";
export default {
    name: "AndharBaharView",
    props: ['rowsrec'],
    data() {
        return {
            startnum: null,
            isActive: false,
            userdetails: {
                username: null,
                balance: null,
                period: null,
                slide: 48,

            },
            image: {
                i1: require('@/assets/includes/ab/1.png'),
                i2: require('@/assets/includes/ab/2.png'),
                i3: require('@/assets/includes/ab/3.png'),
                i4: require('@/assets/includes/ab/4.png'),
                i5: require('@/assets/includes/ab/5.png'),
                i6: require('@/assets/includes/ab/6.png'),
                i7: require('@/assets/includes/ab/7.png'),
                i8: require('@/assets/includes/ab/8.png'),
                i9: require('@/assets/includes/ab/9.png'),
                andar: require('@/assets/includes/ab/and_bk.png'),
                middle: require('@/assets/includes/ab/avbcards_bk.png'),
                bahar: require('@/assets/includes/ab/bnd_bk.png'),
            },
            betbox: {
                ani: null,
                title: null,
                target: null,
                boxcolor: null,
                timeout: true,
                multiply: 1,
                factor: 10,
                amount: 10,
                page: 1,
                page1: 1,
                total: 1000,
                total1: null,

            },
            result:{
                period:0,
                price:0,
                number:null,
                ans:null,
                res:null,
                amount:0,
            },
            resultrec: '',
            info: '',
            betrec: ''
        }

    },
    mounted: function () {
        this.countdown();
        this.refreshcountdown = setInterval(this.countdown, 1000);
        if (this.startnum != null) {
            this.st();
        } else {
            this.m = setInterval(this.st, 1000);
        }
    },
    beforeUnmount: function () {
        console.log("unmount");
        clearInterval(this.refreshcountdown);

    },
    created: function () {
        this.fechresultrec();

        // this.expand();
    },
    methods: {
        resclass(res){
            if (res == 'A') {
                return 'GS A selcol';
            } else if (res == 'B') {
                return 'RS B selcol';
            } else if (res == 'T') {
                return 'VS T selcol';
            }
        
    },
    getcl(res){
        if (res == 'A') {
                return 'GXL A';
            } else if (res == 'B') {
                return 'RXL B';
            } else if (res == 'T') {
                return 'VSL T';
            }
    },
    resopen(){
            document.getElementById("rlink").style.display = "";
        },
        resclose(){
            document.getElementById("rlink").style.display = "none";
        },getrcl(res){
        if(res=="success"){
            return 'col-12 wnls win';
        }else{
            return 'col-12 wnls loss';
        }
       },
       getr(res){
        if(res=="success"){
            return 'WIN';
        }else{
            return 'LOSS';
        }
       },
        moveup() {
            document.getElementById("upimg" + this.startnum).style.marginTop = "0px";
            console.log("start");
        },
        st() {
            if (this.startnum != null) {
                clearInterval(this.m);
                document.getElementById("upimg" + this.startnum).style.display = "";
                this.move = setTimeout(this.moveup, 1000);
                
            } else {
                document.getElementById("upimg" + this.startnum).style.display = "";
                this.move = setTimeout(this.moveup, 1000);
               
            }

        },

        getresclass(res) {
            if (res == 'A') {
                return 'GS A';
            } else if (res == 'B') {
                return 'RS B';
            } else if (res == 'T') {
                return 'VS T';
            }
        },
        pop(message) {
            document.getElementById("message").innerHTML = message;
            document.getElementById("clink").style.display = "";

        }, cpop() {
            document.getElementById("clink").style.display = "none";

        },
        fechresultrec() {

            axios.get('https://fiewin.source-code.co.in/Gameapi/src/api/bet.php?action=result&server=AndharBahar').then((res) => {
                this.resultrec = res.data;
            }).catch((err) => {
                console.log(err);
            })
            this.userdetails.username = localStorage.getItem('username');
            axios.get('https://fiewin.source-code.co.in/Gameapi/src/api/bet.php?action=betrec&user=' + this.userdetails.username + '&server=AndharBahar').then((res) => {
                this.betrec = res.data;
                console.log(this.betrec);
                this.result.period=this.betrec[0].period;
                this.result.price=Math.floor(Math.random() * (5000 - 4000 + 1)) + 4000;
                this.result.number=this.betrec[0].number;
                this.result.ans=this.betrec[0].ans;
                this.result.amount=this.betrec[0].amount;
                this.result.res=this.betrec[0].res;
                
            }).catch((err) => {
                console.log(err);
            })

            axios.get('https://fiewin.source-code.co.in/Gameapi/src/api/bet.php?action=info&user=' + this.userdetails.username + '&per=AndharBahar').then((res) => {
                this.info = res.data;
                this.betbox.total = this.info[1].total;
                this.betbox.total1 = this.info[3].total1;
                this.userdetails.balance = this.info[0].balance;
                this.userdetails.period = this.info[2].period;
                this.startnum = this.info[4].startnum;

            }).catch((err) => {
                console.log(err);
            })
        },
        reset() {
            document.getElementById("a1").style.display = "none";
            document.getElementById("a2").style.display = "none";
            document.getElementById("a3").style.display = "none";
            document.getElementById("a4").style.display = "none";
            document.getElementById("a5").style.display = "none";
            document.getElementById("a6").style.display = "none";
            document.getElementById("a7").style.display = "none";
            document.getElementById("a8").style.display = "none";
            document.getElementById("a9").style.display = "none";

            document.getElementById("m1").style.display = "none";
            document.getElementById("m2").style.display = "none";
            document.getElementById("m3").style.display = "none";
            document.getElementById("m4").style.display = "none";
            document.getElementById("m5").style.display = "none";
            document.getElementById("m6").style.display = "none";
            document.getElementById("m7").style.display = "none";
            document.getElementById("m8").style.display = "none";
            document.getElementById("m9").style.display = "none";



            document.getElementById("b1").style.display = "none";
            document.getElementById("b2").style.display = "none";
            document.getElementById("b3").style.display = "none";
            document.getElementById("b4").style.display = "none";
            document.getElementById("b5").style.display = "none";
            document.getElementById("b6").style.display = "none";
            document.getElementById("b7").style.display = "none";
            document.getElementById("b8").style.display = "none";
            document.getElementById("b9").style.display = "none";
        },
        betamount(x, z, a) {
            var amount;
            var f;
            if (z == "fail") {
                f = 95 / 100 * x;
                amount = "<r> -₹" + (f.toFixed(2)) + "</r>";
                return amount;
            } else if (z == 'success') {
                if (a == "A" || a == "B") {
                    f = 95 / 100 * x * 2;
                    amount = "<g>+₹" + f.toFixed(2) + "</g>";
                    return amount;
                } else {
                    f = 95 / 100 * x * 9;
                    amount = "<g>+v" + f.toFixed(2) + "</g>";
                    return amount;
                }


            } else {
                return "<span class='icon wait'></span>";
            }
        },
        readrule() {

            document.getElementById("xrule").style.display = "";
        },
        closerule() {
            document.getElementById("xrule").style.display = "none";
        },
        join(label) {
            console.log(label);
            if (this.betbox.timeout) {
                if (label == "Andhar") {
                    this.userdetails.slide = "A";
                    this.betbox.boxcolor = "#6298e8";
                    this.betbox.title = "Andar";
                } else if (label == "Bahar") {
                    this.userdetails.slide = "B";
                    this.betbox.boxcolor = "red";
                    this.betbox.title = "Bahar";
                } else if (label == "Tie") {
                    this.userdetails.slide = "T";
                    this.betbox.boxcolor = "tie";
                    this.betbox.title = "Tie";
                }

                document.getElementById("nfrm").style.display = "block";
                document.getElementById("blackscreen").style.display = "block";
                this.fechresultrec();
            }

        },
        closescreen() {
            document.getElementById("nfrm").style.display = "none";
            document.getElementById("blackscreen").style.display = "none";
        },
        betclass(name) {
            return name + ' ' + this.betbox.boxcolor;
        },

        closebetbox() {
            document.getElementById("betbox").style.display = "none";
            var listItems = document.getElementById('factorlist').childNodes;
            // Remove 'active' tag for all list items
            for (let i = 0; i < listItems.length; i++) {
                listItems[i].classList.remove('active');
            }
            this.betbox.amount = this.betbox.factor * this.betbox.multiply
            document.getElementById("10").className = "active";
            this.betbox.multiply = 1;
            this.betbox.factor = 10;
            this.betbox.amount = 10;
        },
        selectmultiply(multi) {
            var listItems = document.getElementById('factorlist').childNodes;
            // Remove 'active' tag for all list items
            for (let i = 0; i < listItems.length; i++) {
                listItems[i].classList.remove('selected');
            }
            this.betbox.factor = multi;
            this.betbox.amount = this.betbox.factor * this.betbox.multiply
            document.getElementById(multi).className = "cont-amt selected " + this.betbox.target;
        },
        plus(value) {
            this.betbox.multiply = this.betbox.multiply + value;
            this.betbox.amount = this.betbox.factor * this.betbox.multiply
        },
        minus(value) {
            if (this.betbox.multiply > value) {
                this.betbox.multiply = this.betbox.multiply - value;
                this.betbox.amount = this.betbox.factor * this.betbox.multiply
            }

        },
        myorder() {
            document.getElementById("every").classList.remove("active");
            document.getElementById("my").classList.add("active");
            document.getElementById("myorder").style.display = "";
            document.getElementById("everyoneorder").style.display = "none";
        },
        everyoneorder() {
            document.getElementById("my").classList.remove("active");
            document.getElementById("every").classList.add("active");
            document.getElementById("myorder").style.display = "none";
            document.getElementById("everyoneorder").style.display = "";
        },
        countdown() {
            var countDownDate = Date.parse(new Date) / 1e3;
            //var now = new Date().getTime();
            var distance = 60 - countDownDate % 60;
            //alert(distance);
            var i = distance / 60,
                n = distance % 60;
            //o = n / 10,
            // s = n % 10;
            var minutes = Math.floor(i);
            var seconds = ('0' + Math.floor(n)).slice(-2);
            var sec1 = (seconds % 100 - seconds % 10) / 10;
            var sec2 = seconds % 10;
            document.getElementById("demo").innerHTML = "<span class='cdspn'>0</span><span class='cdspn' id='fsm'> " + Math.floor(minutes) + "</span>:<span class='cdspn' id='fs0'>" + sec1 + "</span><span class='cdspn' id='fs1'>" + sec2 + "</span>";

            if (11 > distance) {
                document.getElementById("jaba").classList.add("disabled");
                document.getElementById("jabb").classList.add("disabled");
                document.getElementById("jabt").classList.add("disabled");

                document.getElementById("everyone").stop();
                document.getElementById("blackscreen").style.display = "none";
                this.betbox.timeout = false;
            }
            if (60 == distance) {
                document.getElementById("demo").style.display = "none";
                document.getElementById("ndemo").style.display = "";
            }
            if (59 == distance) {
                axios.get('https://fiewin.source-code.co.in/Gameapi/src/api/bet.php?action=result&server=AndharBahar').then((res) => {
                    this.ani = res.data[res.data.length - 1].clo;
                    console.log(this.ani);
                    this.animate(this.ani);
                }).catch((err) => {
                    console.log(err);
                })
            }




        },
        toggle(idx) {
            if (document.getElementById(idx).style.display == "") {
                document.getElementById(idx).style.display = "none";
            } else {
                document.getElementById(idx).style.display = "";
            }
        },
        confirmbet() {
            document.getElementById("nfrm").style.display = "none";
            document.getElementById("blackscreen").style.display = "none";
            if (this.userdetails.balance >= this.betbox.amount) {
                var data = new FormData();
                data.append("username", this.userdetails.username);
                data.append("period", this.userdetails.period);
                data.append("amount", this.betbox.amount);
                data.append("ans", this.userdetails.slide);
                axios
                    .post(
                        "https://fiewin.source-code.co.in/Gameapi/src/api/bet.php?action=bet&server=AndharBahar",
                        data
                    )
                    .then(res => {
                        console.log(res.data);
                        alert("success");
                        this.closebetbox();
                        this.fechresultrec();
                        
                    })
                    .catch(err => {
                        console.log("Error", err);
                    });
                this.fechresultrec();
            } else {
                this.pop("Low Balance!");
            }

        },
        load() {
            this.fechresultrec();
        },
        moveandar(num) {
            document.getElementById("m" + num).style.display = "";
            document.getElementById("m" + num).style.marginTop = "30px";
            //document.getElementById("m"+num).style.right = "211px";


            let id = null;
            const elem = document.getElementById("m" + num);
            let pos = 0;
            clearInterval(id);
            id = setInterval(frame, 1);
            function frame() {
                if (pos == 210) {
                    clearInterval(id);
                    document.getElementById("a" + num).display = "";
                } else {
                    pos += 5;
                    elem.style.right = pos + 'px';
                }
            }
        },
        movebahar(num) {
            document.getElementById("m" + num).style.display = "";
            document.getElementById("m" + num).style.marginTop = "30px";
            //document.getElementById("m"+num).style.right = "211px";


            let id = null;
            const elem = document.getElementById("m" + num);
            let pos = 0;
            clearInterval(id);
            id = setInterval(frame, 1);
            function frame() {
                if (pos == 210) {
                    clearInterval(id);
                    document.getElementById("b" + num).display = "";
                } else {
                    pos += 5;
                    elem.style.left = pos + 'px';
                }
            }
        },

        getele(ele) {
            if (ele == 'A') {

                return "<div class='GS A'><div class='tpr'>" + ele + "</div></div>"


            } else if (ele == 'B') {

                return "<div class='RS B'><div class='tpr'>" + ele + "</div></div>"

            } else if (ele == 'T') {

                return "<div class='VS T'><div class='tpr'>" + ele + "</div></div>"

            } else {
                return "<div class='' style='margin-left: 25%;'><span class='icon wait'></span></div>"
            }
        },
        short(stat) {
            if (stat == "red") {
                return 'R';
            } else if (stat == "green") {
                return 'G';
            } else if (stat == "violet") {
                return 'V';
            } else {
                return stat;
            }
        },
        animate(statement) {
            this.resultst = statement
            this.id = null;
            this.fps = 0;
            this.id = setInterval(this.play, 1000);

        },
        play() {
            console.log(this.resultst, this.fps, this.resultst.length)
            if (this.fps == this.resultst.length) {
                clearInterval(this.id);
                this.betbox.timeout = true;
                document.getElementById("demo").style.display = "";
                document.getElementById("ndemo").style.display = "none";
                document.getElementById("jaba").classList.remove("disabled");
                document.getElementById("jabb").classList.remove("disabled");
                document.getElementById("jabt").classList.remove("disabled");

                this.fechresultrec();
                document.getElementById("everyone").start();
                this.reset();
                this.st = setTimeout(this.st, 1000);
                if(this.betrec[0].period==(this.userdetails.period-1)){
                this.resopen();
               }
            } else {
                if (this.fps % 2 == 0) {
                    console.log(this.resultst[this.fps]);
                    this.moveandar(this.resultst[this.fps]);
                } else {
                    console.log(this.resultst[this.fps]);
                    this.movebahar(this.resultst[this.fps]);
                }
                this.fps = this.fps + 1;
            }
        }



    }
}

</script>